import { useContext, useEffect, useRef } from 'react';
import {
    ActionDependant,
    evaluateTemplateValue,
    GlobalDataContext,
    TemplateContext,
} from '@ea-lab/reactive-json';
import { DocFiltersContext } from '../DocFiltersContext';

/**
 * Pont INVISIBLE entre le magasin reactive-json d'une page doc et l'état React
 * partagé du module (`DocFiltersContext`) — le seul point où les deux se
 * rencontrent, dans les deux sens :
 *
 *   • page → contexte : les catégories d'espace, dont le formulaire de création
 *     d'espace et les réglages d'un répertoire ont besoin ;
 *   • contexte → page : la demande d'ouverture du formulaire de création (le
 *     bouton « + » de la barre latérale, qui est du React), et `isAdmin`, lu par
 *     le YAML pour n'afficher qu'aux administrateurs l'accès à la gestion des
 *     groupes wiki.
 *
 * Ne rend rien.
 */
export const DocHubBridge = ({ props }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);
    const filtersCtx = useContext(DocFiltersContext);

    const ev = (val) =>
        evaluateTemplateValue({ valueToEvaluate: val, globalDataContext, templateContext });

    const spaceCategories = ev(props.spaceCategories);
    const showSpaceFormPath = props.showSpaceFormPath || 'showSpaceForm';

    const prevCategoriesRef = useRef(null);

    useEffect(() => {
        if (!filtersCtx || spaceCategories === prevCategoriesRef.current) return;
        prevCategoriesRef.current = spaceCategories;
        if (Array.isArray(spaceCategories)) filtersCtx.setSpaceCategories(spaceCategories);
    }, [spaceCategories, filtersCtx]);

    useEffect(() => {
        if (!filtersCtx) return;
        if (filtersCtx.showSpaceForm) {
            globalDataContext.updateData(true, showSpaceFormPath);
            filtersCtx.setShowSpaceForm(false);
        }
    }, [filtersCtx?.showSpaceForm, globalDataContext, showSpaceFormPath, filtersCtx]);

    useEffect(() => {
        if (!filtersCtx) return;
        globalDataContext.updateData(!!filtersCtx.isAdmin, 'isAdmin');
    }, [filtersCtx?.isAdmin, globalDataContext]);

    return <ActionDependant {...props}><span className="hidden" /></ActionDependant>;
};
